import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getPendingApproval = async (params) => {
	const { data } = await axios.get(`${API}/client/products/pending-approval`, {
		params,
	});
	return data;
};

export const saveApproval = async (params) => {
	const { data } = await axios.post(`${API}/client/products/pending-approval-save`, params);
	return data;
};
